import { useMemo } from 'react';

export const useSalesforceAuth = () => {
  const sfToken = sessionStorage.getItem('SFToken') || '';
  const sfEdit = sessionStorage.getItem('sf_edit') || '';
  const sfMarked = sessionStorage.getItem('sf_marked') || '';
  const sfDelete = sessionStorage.getItem('sf_delete') || '';
  const sfEditSelected = sessionStorage.getItem('sf_edit_selected') || '';

  const parseSf = useMemo(() => {
    let parsed = {
      access_token: '',
      id: '',
      instance_url: '',
      issued_at: '',
      refresh_token: '',
      scope: '',
      signature: '',
      token_type: '',
    };
    if (sfToken) {
      try {
        parsed = JSON.parse(sfToken);
      } catch (e) {
      }
    }
    return parsed;
  }, [sfToken]);

  const isSalesforceAuthenticated = sfToken === 'true';

  return {
    sfToken,
    sfEdit,
    sfMarked,
    sfDelete,
    sfEditSelected,
    parseSf,
    isSalesforceAuthenticated,
  };
};
